<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">A Nourishing Network</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Hybrid publishing, web-to-print, network, commissioned work</p>
<p>A Nourishing Network is a publishing experiment starting from the feed as a potentially multi-directional circulation device. The project documents and circulates current research done by a network of artists, activists and programmers that collaborate with the Austrian net culture initiative servus.at.</p>
<p>Throughout the duration of the project, people subscribed to either a physical or a digital feed (or both) and regularly received publications in their mailbox. The physical publications were designed with markdown and CSS. They were sent in custom envelopes that included 2 identical publications and an extra envelope, to be sent further and thus grow the network.</p>
 <p><a href="https://a-nourishing-network.radical-openness.org/">A Nourishing Network</a> was initiated by servus.at (Davide Bevilacqua) in collaboration with
varia.zone (Manetta Berends) and published in the context of AMRO 2020
(Arts Meets Radical Openness).</p>

      </div>
      </b-col>

      <b-col md="8">
              <b-row>
                <b-col md="6">
                  <b-img class="img-fluid" src="media/ann/pubs.jpg"></b-img>
            </b-col>
                <b-col md="6">
                  <b-img class="img-fluid" src="media/ann/envelopes.jpg"></b-img>

                  <p></p>
            </b-col>

          </b-row>
          <b-row>
            <b-col md="6">
              <p></p>
              <b-img class="img-fluid" src="media/ann/stacks.JPG"></b-img>

        </b-col>
      </b-row>
      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'ANNPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
